export const EnumObjectTypes = {
  User: 1,
  Administrator: 2,
}

export const EnumRoleTypes = {
  Host: 1,
  Administrator: 2,
  Participant: 3,
}

export const EnumRoles = {
  Super_Admin: 1,
  User: 2,
}

export const EnumQuestionTypes = {
  Social_Isolation: 1,
  Nutrition: 2,
  Mental_Health: 3,
  Health_Literacy: 4,
  Chair_Stand: 5,
}
